/* eslint-disable no-console */

import type {
  TCoverColor,
  TGender,
  THairColor,
  TSkinColor,
} from '@shared/common/product';
import {
  INPUT_VALUE_ENGLISH,
  INPUT_VALUE_JAPANESE,
} from '@shared/common/product';
import type { IBookThisIsMyDreamLineData } from '@shared/jp/models';
import type {
  TChildLikesTIMDL,
  TClothColorTIMDL,
  THairStyleBoyTIMDL,
  THairStyleGirlTIMDL,
  TLanguage,
} from '@shared/jp/product';
import { KUNCHAN_VALUE_TO_LABEL_MAP, languageArr } from '@shared/jp/product';
import {
  resolveAssetElement,
  segmentsListToFontsMap,
} from '@studiobuki/web-core/lib/book-common';
import type {
  TermsWelcomeToTheWold,
  PageTermsWelcomeToTheWold,
  Segment,
  ImageElement,
  TextElement,
  AssetElement,
  Page,
  TextStyle,
} from '@studiobuki/web-core/lib/book-common';
import { isNode } from 'browser-or-node';
import { jp } from './locale';
import { KEY_KIDS_HERONAME, KEY_KIDS_TITLE } from './_constants';
import { KEY_GENDER_INDEX } from '../../book-lets-make-metro-page/segments/_constants';
import { Wahupop_000000_24 } from './locale/jp/_styles';

type TSegmentTermsType = TermsWelcomeToTheWold;
type TPageTermsType = PageTermsWelcomeToTheWold;

type TSegment = Segment<
  TSegmentTermsType,
  TPageTermsType,
  IBookThisIsMyDreamLineData
>;

type TLeftTextElementStyle = Partial<TextStyle> &
  Required<Pick<TextStyle, 'fontSize' | 'fontFamily' | 'fill'>>;
const leftTextElement = (
  bookData: IBookThisIsMyDreamLineData,
  _text: string,
  baseY: number,
  _lgStyle: TLeftTextElementStyle,
  _smStyle: TLeftTextElementStyle,
  lgWidth: number,
  smWidth: number,
  xToAdd: number,
) => {
  const textArr: TextElement[] = [];
  const text = textProcessor(bookData, _text);

  const baselineK = 0.2;

  const baseStyle = {
    letterSpacing: 1,
    lineHeight: 1.9,
  } as const;

  const lgStyle: TextStyle = {
    ...baseStyle,
    ..._lgStyle,
  };

  // @ts-ignore
  const lgHeight = lgStyle.fontSize * lgStyle.lineHeight;
  const smStyle: TextStyle = {
    ...baseStyle,
    ..._smStyle,
  };

  // @ts-ignore
  const smHeight = smStyle.fontSize * smStyle.lineHeight;
  textArr.push(
    ...text.split('').reduce<TextElement[]>((acc, symbol, i, arr) => {
      if (['[', ']'].includes(symbol)) return acc;

      const prevSymbol = arr[i - 1];
      const prevText = acc[acc.length - 1];
      const isPrevBig = prevText?.style === lgStyle;
      const isBig =
        prevSymbol === ']' ? false : prevSymbol === '[' ? true : isPrevBig;

      acc.push({
        text: symbol,
        style: isBig ? lgStyle : smStyle,
        // @ts-ignore
        x: prevText ? prevText.x + (isPrevBig ? lgWidth : smWidth) : 0,
        y: isBig
          ? baseY
          : baseY +
            (lgHeight - lgHeight * baselineK) -
            // (smHeight - smHeight * baselineK),
            (smHeight + smHeight * baselineK),
      });

      return acc;
    }, []),
  );

  // * center text

  // const xToAdd = 125;

  textArr.forEach((_text) => {
    // @ts-ignore
    _text.x += xToAdd;
  });

  return textArr;
};

type TCenterTextElementStyle = Partial<TextStyle> &
  Required<Pick<TextStyle, 'fontSize' | 'fontFamily' | 'fill'>>;
const centerTextElement = (
  bookData: IBookThisIsMyDreamLineData,
  _text: string,
  baseY: number,
  _lgStyle: TCenterTextElementStyle,
  _smStyle: TCenterTextElementStyle,
  lgWidth: number,
  smWidth: number,
) => {
  const textArr: TextElement[] = [];
  const text = textProcessor(bookData, _text);
  const baseWidth = 842;
  const baselineK = 0.08;

  const baseStyle = {
    letterSpacing: 1,
    lineHeight: 1.4,
  } as const;

  const lgStyle: TextStyle = {
    ...baseStyle,
    ..._lgStyle,
  };

  // @ts-ignore
  const lgHeight = lgStyle.fontSize * lgStyle.lineHeight;
  const smStyle: TextStyle = {
    ...baseStyle,
    ..._smStyle,
  };

  // @ts-ignore
  const smHeight = smStyle.fontSize * smStyle.lineHeight;
  textArr.push(
    ...text.split('').reduce<TextElement[]>((acc, symbol, i, arr) => {
      if (['[', ']'].includes(symbol)) return acc;

      const prevSymbol = arr[i - 1];
      const prevText = acc[acc.length - 1];
      const isPrevBig = prevText?.style === lgStyle;
      const isBig =
        prevSymbol === ']' ? false : prevSymbol === '[' ? true : isPrevBig;

      acc.push({
        text: symbol,
        style: isBig ? lgStyle : smStyle,
        // @ts-ignore
        x: prevText ? prevText.x + (isPrevBig ? lgWidth : smWidth) : 0,
        y: isBig
          ? baseY
          : baseY +
            (lgHeight - lgHeight * baselineK) -
            (smHeight + smHeight * baselineK),
      });

      return acc;
    }, []),
  );

  const fullWidth = textArr.reduce(
    (width, _text) => width + (_text.style === lgStyle ? lgWidth : smWidth),
    0,
  );
  const xToAdd = baseWidth / 2 - fullWidth / 2;

  textArr.forEach((_text) => {
    // @ts-ignore
    _text.x += xToAdd;
  });

  return textArr;
};
const centerTextElement5 = (
  bookData: IBookThisIsMyDreamLineData,
  _text: string,
  baseY: number,
  _lgStyle: TCenterTextElementStyle,
  _smStyle: TCenterTextElementStyle,
  lgWidth: number,
  smWidth: number,
) => {
  const textArr: TextElement[] = [];
  const text = textProcessor(bookData, _text);
  const baseWidth = 470;
  const baselineK = 0.08;

  const baseStyle = {
    letterSpacing: 1,
    lineHeight: 1.4,
  } as const;

  const lgStyle: TextStyle = {
    ...baseStyle,
    ..._lgStyle,
  };

  // @ts-ignore
  const lgHeight = lgStyle.fontSize * lgStyle.lineHeight;
  const smStyle: TextStyle = {
    ...baseStyle,
    ..._smStyle,
  };

  // @ts-ignore
  const smHeight = smStyle.fontSize * smStyle.lineHeight;
  textArr.push(
    ...text.split('').reduce<TextElement[]>((acc, symbol, i, arr) => {
      if (['[', ']'].includes(symbol)) return acc;

      const prevSymbol = arr[i - 1];
      const prevText = acc[acc.length - 1];
      const isPrevBig = prevText?.style === lgStyle;
      const isBig =
        prevSymbol === ']' ? false : prevSymbol === '[' ? true : isPrevBig;

      acc.push({
        text: symbol,
        style: isBig ? lgStyle : smStyle,
        // @ts-ignore
        x: prevText ? prevText.x + (isPrevBig ? lgWidth : smWidth) : 0,
        y: isBig
          ? baseY
          : baseY +
            (lgHeight - lgHeight * baselineK) -
            (smHeight + smHeight * baselineK),
      });

      return acc;
    }, []),
  );

  const fullWidth = textArr.reduce(
    (width, _text) => width + (_text.style === lgStyle ? lgWidth : smWidth),
    0,
  );
  const xToAdd = baseWidth / 2 - fullWidth / 2;

  textArr.forEach((_text) => {
    // @ts-ignore
    _text.x += xToAdd;
  });

  return textArr;
};
const centerTextElement30 = (
  bookData: IBookThisIsMyDreamLineData,
  _text: string,
  baseY: number,
  _lgStyle: TCenterTextElementStyle,
  _smStyle: TCenterTextElementStyle,
  lgWidth: number,
  smWidth: number,
) => {
  const textArr: TextElement[] = [];
  const text = textProcessor(bookData, _text);
  const baseWidth = 945;
  const baselineK = 0.08;

  const baseStyle = {
    letterSpacing: 1,
    lineHeight: 1.4,
  } as const;

  const lgStyle: TextStyle = {
    ...baseStyle,
    ..._lgStyle,
  };

  // @ts-ignore
  const lgHeight = lgStyle.fontSize * lgStyle.lineHeight;
  const smStyle: TextStyle = {
    ...baseStyle,
    ..._smStyle,
  };

  // @ts-ignore
  const smHeight = smStyle.fontSize * smStyle.lineHeight;
  textArr.push(
    ...text.split('').reduce<TextElement[]>((acc, symbol, i, arr) => {
      if (['[', ']'].includes(symbol)) return acc;

      const prevSymbol = arr[i - 1];
      const prevText = acc[acc.length - 1];
      const isPrevBig = prevText?.style === lgStyle;
      const isBig =
        prevSymbol === ']' ? false : prevSymbol === '[' ? true : isPrevBig;

      acc.push({
        text: symbol,
        style: isBig ? lgStyle : smStyle,
        // @ts-ignore
        x: prevText ? prevText.x + (isPrevBig ? lgWidth : smWidth) : 0,
        y: isBig
          ? baseY
          : baseY +
            (lgHeight - lgHeight * baselineK) -
            (smHeight + smHeight * baselineK),
      });

      return acc;
    }, []),
  );

  const fullWidth = textArr.reduce(
    (width, _text) => width + (_text.style === lgStyle ? lgWidth : smWidth),
    0,
  );
  const xToAdd = baseWidth / 2 - fullWidth / 2;

  textArr.forEach((_text) => {
    // @ts-ignore
    _text.x += xToAdd;
  });

  return textArr;
};
const centerTextElementOnArc = (
  bookData: IBookThisIsMyDreamLineData,
  _text: string,
  baseY: number,
  _lgStyle: TCenterTextElementStyle,
  _smStyle: TCenterTextElementStyle,
  lgWidth: number,
  smWidth: number,
  radius = 700,
) => {
  const textArr: TextElement[] = [];
  const text = textProcessor(bookData, _text);

  const baseWidth = 842;
  const baselineK = 0.08;

  const baseStyle = {
    letterSpacing: 1,
    lineHeight: 1.4,
  } as const;

  const lgStyle: TextStyle = {
    ...baseStyle,
    ..._lgStyle,
  };

  // @ts-ignore
  const lgHeight = lgStyle.fontSize * lgStyle.lineHeight;

  const smStyle: TextStyle = {
    ...baseStyle,
    ..._smStyle,
  };

  // @ts-ignore
  const smHeight = smStyle.fontSize * smStyle.lineHeight;

  // Сначала создаём символы и считаем их позиции
  text.split('').reduce<TextElement[]>((acc, symbol, i, arr) => {
    if (['[', ']'].includes(symbol)) return acc;

    const prevSymbol = arr[i - 1];
    const prevText = acc[acc.length - 1];

    const isPrevBig = prevText?.style === lgStyle;

    const isBig =
      prevSymbol === ']' ? false : prevSymbol === '[' ? true : isPrevBig;

    acc.push({
      text: symbol,
      style: isBig ? lgStyle : smStyle,

      // Временная позиция.
      // После этого она будет заменена координатами дуги.
      // @ts-ignore
      x: prevText ? prevText.x + (isPrevBig ? lgWidth : smWidth) : 0,

      y: isBig
        ? baseY
        : baseY +
          (lgHeight - lgHeight * baselineK) -
          (smHeight + smHeight * baselineK),
    });

    return acc;
  }, textArr);

  // ---------------------------------------------------------
  // Общая ширина текста
  // ---------------------------------------------------------

  const fullWidth = textArr.reduce(
    (width, item) => width + (item.style === lgStyle ? lgWidth : smWidth),
    0,
  );

  // ---------------------------------------------------------
  // Центр дуги
  // ---------------------------------------------------------

  const centerX = baseWidth / 2;

  // Угол дуги.
  //
  // Текст располагается по верхней части окружности.
  //
  // Чем больше radius, тем более пологая дуга.
  // ---------------------------------------------------------

  const totalAngle = 2 * Math.asin(fullWidth / (2 * radius));

  let currentDistance = 0;

  textArr.forEach((item) => {
    const itemWidth = item.style === lgStyle ? lgWidth : smWidth;

    // Центр текущего символа
    const itemCenter = currentDistance + itemWidth / 2;

    // Перевод расстояния по прямой в угол
    const angle = -Math.PI / 2 + (itemCenter / fullWidth - 0.5) * totalAngle;

    // Центр окружности.
    //
    // baseY здесь является верхней точкой дуги.
    const circleCenterY = baseY + radius;

    const x = centerX + Math.cos(angle) * radius;

    const y = circleCenterY + Math.sin(angle) * radius;

    // Угол самого символа.
    //
    // Касательная к окружности.
    const rotation = (angle + Math.PI / 2) * (180 / Math.PI);

    // @ts-ignore
    item.x = x - itemWidth / 2;

    // @ts-ignore
    item.y = y;

    // Если TextElement поддерживает rotation
    // @ts-ignore
    item.rotation = rotation;

    currentDistance += itemWidth;
  });

  return textArr;
};
export const textProcessor = (
  bookData: IBookThisIsMyDreamLineData,
  _textStr: string,
): string => {
  let textStr = _textStr;

  textStr = textStr.replace(
    new RegExp(`${KEY_KIDS_TITLE}`, 'gi'),
    bookData.kunChan === 'nashi'
      ? ''
      : KUNCHAN_VALUE_TO_LABEL_MAP[bookData.kunChan],
  );

  textStr = textStr.replace(
    new RegExp(`${KEY_GENDER_INDEX}`, 'gi'),
    bookData.gender === 'boy' ? 'ぼく' : 'わたし',
  );

  textStr = textStr.replace(
    new RegExp(`${KEY_KIDS_HERONAME}`, 'gi'),
    bookData.heroName,
  );
  return textStr;
};

type LikeConfigElement = ImageElement | AssetElement<{ assetLike: string }>;

type LikeConfig = {
  [like1 in TChildLikesTIMDL]?: {
    [like2 in TChildLikesTIMDL]?: {
      [like3 in TChildLikesTIMDL]?: LikeConfigElement;
    };
  };
};

const likeConfig: LikeConfig = {
  nature: {
    archeology: {
      food: {
        type: 'AssetElement',
        asset: { assetLike: '01' },
      },
      princesses: {
        type: 'AssetElement',
        asset: { assetLike: '02' },
      },
      animals: {
        type: 'AssetElement',
        asset: { assetLike: '03' },
      },
      art: {
        type: 'AssetElement',
        asset: { assetLike: '04' },
      },
    },

    food: {
      princesses: {
        type: 'AssetElement',
        asset: { assetLike: '05' },
      },
      animals: {
        type: 'AssetElement',
        asset: { assetLike: '06' },
      },
      art: {
        type: 'AssetElement',
        asset: { assetLike: '07' },
      },
    },

    princesses: {
      animals: {
        type: 'AssetElement',
        asset: { assetLike: '08' },
      },
      art: {
        type: 'AssetElement',
        asset: { assetLike: '09' },
      },
    },

    animals: {
      art: {
        type: 'AssetElement',
        asset: { assetLike: '10' },
      },
    },
  },

  archeology: {
    food: {
      princesses: {
        type: 'AssetElement',
        asset: { assetLike: '11' },
      },
      animals: {
        type: 'AssetElement',
        asset: { assetLike: '12' },
      },
      art: {
        type: 'AssetElement',
        asset: { assetLike: '13' },
      },
    },

    princesses: {
      animals: {
        type: 'AssetElement',
        asset: { assetLike: '14' },
      },
      art: {
        type: 'AssetElement',
        asset: { assetLike: '15' },
      },
    },

    animals: {
      art: {
        type: 'AssetElement',
        asset: { assetLike: '16' },
      },
    },
  },

  food: {
    princesses: {
      animals: {
        type: 'AssetElement',
        asset: { assetLike: '17' },
      },
      art: {
        type: 'AssetElement',
        asset: { assetLike: '18' },
      },
    },

    animals: {
      art: {
        type: 'AssetElement',
        asset: { assetLike: '19' },
      },
    },
  },

  princesses: {
    animals: {
      art: {
        type: 'AssetElement',
        asset: { assetLike: '20' },
      },
    },
  },
};

/** ! reuses lets-make-metro illustration assets (same hair-style ids) as a stand-in until dedicated art exists */
const skinColorConfig: {
  [clothColor in TClothColorTIMDL]: {
    [skinColor in TSkinColor]:
      | ImageElement
      | AssetElement<{ assetSkin: string }>;
  };
} = {
  green: {
    white: { type: 'AssetElement', asset: { assetSkin: '01' } },
    nutmeg: { type: 'AssetElement', asset: { assetSkin: '02' } },
    brown: { type: 'AssetElement', asset: { assetSkin: '03' } },
    black: { type: 'AssetElement', asset: { assetSkin: '04' } },
  },
  red: {
    white: { type: 'AssetElement', asset: { assetSkin: '05' } },
    nutmeg: { type: 'AssetElement', asset: { assetSkin: '06' } },
    brown: { type: 'AssetElement', asset: { assetSkin: '07' } },
    black: { type: 'AssetElement', asset: { assetSkin: '08' } },
  },
  blue: {
    white: { type: 'AssetElement', asset: { assetSkin: '09' } },
    nutmeg: { type: 'AssetElement', asset: { assetSkin: '10' } },
    brown: { type: 'AssetElement', asset: { assetSkin: '11' } },
    black: { type: 'AssetElement', asset: { assetSkin: '12' } },
  },
};

const hairColorConfig: {
  [gender in TGender]: {
    [hairColor in THairColor]: {
      [hairStyle in THairStyleBoyTIMDL | THairStyleGirlTIMDL]:
        | ImageElement
        | AssetElement<{ assetHair: string }>;
    };
  };
} = {
  boy: {
    blonde: {
      very_short: { type: 'AssetElement', asset: { assetHair: '01' } },
      short: { type: 'AssetElement', asset: { assetHair: '02' } },
      mushroom: { type: 'AssetElement', asset: { assetHair: '03' } },
      long: { type: 'AssetElement', asset: { assetHair: '04' } },
      wavy: { type: 'AssetElement', asset: { assetHair: '05' } },
      curly: { type: 'AssetElement', asset: { assetHair: '06' } },
      short_bob: { type: 'AssetElement', asset: { assetHair: '00' } },
      medium_bob: { type: 'AssetElement', asset: { assetHair: '00' } },
      pig_tail: { type: 'AssetElement', asset: { assetHair: '00' } },
    },
    red: {
      very_short: { type: 'AssetElement', asset: { assetHair: '07' } },
      short: { type: 'AssetElement', asset: { assetHair: '08' } },
      mushroom: { type: 'AssetElement', asset: { assetHair: '09' } },
      long: { type: 'AssetElement', asset: { assetHair: '10' } },
      wavy: { type: 'AssetElement', asset: { assetHair: '11' } },
      curly: { type: 'AssetElement', asset: { assetHair: '12' } },
      short_bob: { type: 'AssetElement', asset: { assetHair: '00' } },
      medium_bob: { type: 'AssetElement', asset: { assetHair: '00' } },
      pig_tail: { type: 'AssetElement', asset: { assetHair: '00' } },
    },
    brown: {
      very_short: { type: 'AssetElement', asset: { assetHair: '13' } },
      short: { type: 'AssetElement', asset: { assetHair: '14' } },
      mushroom: { type: 'AssetElement', asset: { assetHair: '15' } },
      long: { type: 'AssetElement', asset: { assetHair: '16' } },
      wavy: { type: 'AssetElement', asset: { assetHair: '17' } },
      curly: { type: 'AssetElement', asset: { assetHair: '18' } },
      short_bob: { type: 'AssetElement', asset: { assetHair: '00' } },
      medium_bob: { type: 'AssetElement', asset: { assetHair: '00' } },
      pig_tail: { type: 'AssetElement', asset: { assetHair: '00' } },
    },
    black: {
      very_short: { type: 'AssetElement', asset: { assetHair: '19' } },
      short: { type: 'AssetElement', asset: { assetHair: '20' } },
      mushroom: { type: 'AssetElement', asset: { assetHair: '21' } },
      long: { type: 'AssetElement', asset: { assetHair: '22' } },
      wavy: { type: 'AssetElement', asset: { assetHair: '23' } },
      curly: { type: 'AssetElement', asset: { assetHair: '24' } },
      short_bob: { type: 'AssetElement', asset: { assetHair: '00' } },
      medium_bob: { type: 'AssetElement', asset: { assetHair: '00' } },
      pig_tail: { type: 'AssetElement', asset: { assetHair: '00' } },
    },
  },
  girl: {
    blonde: {
      short: { type: 'AssetElement', asset: { assetHair: '25' } },
      short_bob: { type: 'AssetElement', asset: { assetHair: '26' } },
      medium_bob: { type: 'AssetElement', asset: { assetHair: '27' } },
      long: { type: 'AssetElement', asset: { assetHair: '28' } },
      pig_tail: { type: 'AssetElement', asset: { assetHair: '29' } },
      curly: { type: 'AssetElement', asset: { assetHair: '30' } },
      very_short: { type: 'AssetElement', asset: { assetHair: '00' } },
      mushroom: { type: 'AssetElement', asset: { assetHair: '00' } },
      wavy: { type: 'AssetElement', asset: { assetHair: '00' } },
    },
    red: {
      short: { type: 'AssetElement', asset: { assetHair: '31' } },
      short_bob: { type: 'AssetElement', asset: { assetHair: '32' } },
      medium_bob: { type: 'AssetElement', asset: { assetHair: '33' } },
      long: { type: 'AssetElement', asset: { assetHair: '34' } },
      pig_tail: { type: 'AssetElement', asset: { assetHair: '35' } },
      curly: { type: 'AssetElement', asset: { assetHair: '36' } },
      very_short: { type: 'AssetElement', asset: { assetHair: '00' } },
      mushroom: { type: 'AssetElement', asset: { assetHair: '00' } },
      wavy: { type: 'AssetElement', asset: { assetHair: '00' } },
    },
    brown: {
      short: { type: 'AssetElement', asset: { assetHair: '37' } },
      short_bob: { type: 'AssetElement', asset: { assetHair: '38' } },
      medium_bob: { type: 'AssetElement', asset: { assetHair: '39' } },
      long: { type: 'AssetElement', asset: { assetHair: '40' } },
      pig_tail: { type: 'AssetElement', asset: { assetHair: '41' } },
      curly: { type: 'AssetElement', asset: { assetHair: '42' } },
      very_short: { type: 'AssetElement', asset: { assetHair: '00' } },
      mushroom: { type: 'AssetElement', asset: { assetHair: '00' } },
      wavy: { type: 'AssetElement', asset: { assetHair: '00' } },
    },
    black: {
      short: { type: 'AssetElement', asset: { assetHair: '43' } },
      short_bob: { type: 'AssetElement', asset: { assetHair: '44' } },
      medium_bob: { type: 'AssetElement', asset: { assetHair: '45' } },
      long: { type: 'AssetElement', asset: { assetHair: '46' } },
      pig_tail: { type: 'AssetElement', asset: { assetHair: '47' } },
      curly: { type: 'AssetElement', asset: { assetHair: '48' } },
      very_short: { type: 'AssetElement', asset: { assetHair: '00' } },
      mushroom: { type: 'AssetElement', asset: { assetHair: '00' } },
      wavy: { type: 'AssetElement', asset: { assetHair: '00' } },
    },
  },
};

const ASSETS_ROOT = 'assets/templates_this_is_my_dream_line';

const characterObjects = (
  bookData: IBookThisIsMyDreamLineData,
  templateId: string,
): (ImageElement | TextElement)[] => {
  const patternSkin: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `${ASSETS_ROOT}/${templateId}/M/${templateId}-M{{assetSkin}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/${templateId}/M/${templateId}-M{{assetSkin}}.pdf`,
    depth: 5,
  };
  const patternHair: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `${ASSETS_ROOT}/${templateId}/H/${templateId}-H{{assetHair}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/${templateId}/H/${templateId}-H{{assetHair}}.pdf`,
    depth: 7,
  };
  const patternGlasses: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `${ASSETS_ROOT}/${templateId}/G/${templateId}-G01.png`,
    imagePDFURL: `${ASSETS_ROOT}/${templateId}/G/${templateId}-G01.pdf`,
    depth: 8,
  };

  const objects: (ImageElement | TextElement)[] = [
    resolveAssetElement(
      skinColorConfig[bookData.clothColor][bookData.skinColor],
      patternSkin,
    ),
    resolveAssetElement(
      hairColorConfig[bookData.gender][bookData.hairColor][bookData.hairStyle],
      patternHair,
    ),
  ];

  if (bookData.glasses) {
    objects.push(patternGlasses);
  }

  return objects;
};
const characterObjectsS4 = (
  bookData: IBookThisIsMyDreamLineData,
  templateId: string,
): (ImageElement | TextElement)[] => {
  const patternSkin: ImageElement = {
    type: 'ImageElement',
    x: -17,
    y: -18,
    imageURL: `${ASSETS_ROOT}/${templateId}/M/${templateId}-M{{assetSkin}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/${templateId}/M/${templateId}-M{{assetSkin}}.pdf`,
    depth: 5,
  };
  const patternHair: ImageElement = {
    type: 'ImageElement',
    x: -17,
    y: -18,
    imageURL: `${ASSETS_ROOT}/${templateId}/H/${templateId}-H{{assetHair}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/${templateId}/H/${templateId}-H{{assetHair}}.pdf`,
    depth: 7,
  };
  const patternLike: ImageElement = {
    type: 'ImageElement',
    x: -17,
    y: -18,
    imageURL: `${ASSETS_ROOT}/${templateId}/L/${templateId}-L{{assetLike}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/${templateId}/L/${templateId}-L{{assetLike}}.pdf`,
    depth: 8,
  };
  const patternGlasses: ImageElement = {
    type: 'ImageElement',
    x: -17,
    y: -18,
    imageURL: `${ASSETS_ROOT}/${templateId}/G/${templateId}-G01.png`,
    imagePDFURL: `${ASSETS_ROOT}/${templateId}/G/${templateId}-G01.pdf`,
    depth: 9,
  };

  const objects: (ImageElement | TextElement)[] = [
    resolveAssetElement(
      skinColorConfig[bookData.clothColor][bookData.skinColor],
      patternSkin,
    ),
    resolveAssetElement(
      hairColorConfig[bookData.gender][bookData.hairColor][bookData.hairStyle],
      patternHair,
    ),
  ];

  const like1 = bookData.childLikes[0] ?? 'animals';
  const like2 = bookData.childLikes[1] ?? 'animals';
  const like3 = bookData.childLikes[2] ?? 'animals';
  const likeElement = likeConfig[like1]?.[like2]?.[like3];

  if (likeElement) {
    objects.push(...[resolveAssetElement(likeElement, patternLike)]);
  }
  if (bookData.glasses) {
    objects.push(patternGlasses);
  }

  return objects;
};
const characterObjectsS5 = (
  bookData: IBookThisIsMyDreamLineData,
  templateId: string,
): (ImageElement | TextElement)[] => {
  const patternSkin: ImageElement = {
    type: 'ImageElement',
    x: -17,
    y: -18,
    imageURL: `${ASSETS_ROOT}/${templateId}/M/${templateId}-M{{assetSkin}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/${templateId}/M/${templateId}-M{{assetSkin}}.pdf`,
    depth: 5,
  };
  const patternHair: ImageElement = {
    type: 'ImageElement',
    x: -17,
    y: -18,
    imageURL: `${ASSETS_ROOT}/${templateId}/H/${templateId}-H{{assetHair}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/${templateId}/H/${templateId}-H{{assetHair}}.pdf`,
    depth: 7,
  };
  const patternLike: ImageElement = {
    type: 'ImageElement',
    x: -17,
    y: -18,
    imageURL: `${ASSETS_ROOT}/${templateId}/L/${templateId}-L{{assetLike}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/${templateId}/L/${templateId}-L{{assetLike}}.pdf`,
    depth: 7,
  };

  const objects: (ImageElement | TextElement)[] = [
    resolveAssetElement(
      skinColorConfig[bookData.clothColor][bookData.skinColor],
      patternSkin,
    ),
    resolveAssetElement(
      hairColorConfig[bookData.gender][bookData.hairColor][bookData.hairStyle],
      patternHair,
    ),
  ];

  const like1 = bookData.childLikes[0] ?? 'animals';
  const like2 = bookData.childLikes[1] ?? 'animals';
  const like3 = bookData.childLikes[2] ?? 'animals';
  const likeElement = likeConfig[like1]?.[like2]?.[like3];

  if (likeElement) {
    objects.push(...[resolveAssetElement(likeElement, patternLike)]);
  }

  return objects;
};
const characterObjectsS30 = (
  bookData: IBookThisIsMyDreamLineData,
  templateId: string,
): (ImageElement | TextElement)[] => {
  const patternLike: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `${ASSETS_ROOT}/${templateId}/L/${templateId}-L{{assetLike}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/${templateId}/L/${templateId}-L{{assetLike}}.pdf`,
    depth: 7,
  };

  const objects: (ImageElement | TextElement)[] = [];

  const like1 = bookData.childLikes[0] ?? 'animals';
  const like2 = bookData.childLikes[1] ?? 'animals';
  const like3 = bookData.childLikes[2] ?? 'animals';
  const likeElement = likeConfig[like1]?.[like2]?.[like3];

  if (likeElement) {
    objects.push(...[resolveAssetElement(likeElement, patternLike)]);
  }

  return objects;
};
const characterObjectsS32 = (
  bookData: IBookThisIsMyDreamLineData,
  templateId: string,
): (ImageElement | TextElement)[] => {
  const patternLike: ImageElement = {
    type: 'ImageElement',
    x: 0,
    y: -1,
    imageURL: `${ASSETS_ROOT}/${templateId}/L/${templateId}-L{{assetLike}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/${templateId}/L/${templateId}-L{{assetLike}}.pdf`,
    depth: 7,
  };

  const objects: (ImageElement | TextElement)[] = [];

  const like1 = bookData.childLikes[0] ?? 'animals';
  const like2 = bookData.childLikes[1] ?? 'animals';
  const like3 = bookData.childLikes[2] ?? 'animals';
  const likeElement = likeConfig[like1]?.[like2]?.[like3];

  if (likeElement) {
    objects.push(...[resolveAssetElement(likeElement, patternLike)]);
  }

  return objects;
};
const BLACK = '#000000';

const segment32Pages = (
  bookData: IBookThisIsMyDreamLineData,
): Page<TPageTermsType>[] => {
  const like1 = bookData.childLikes[0]!;
  const like2 = bookData.childLikes[1]!;
  const like3 = bookData.childLikes[2]!;

  const text1 = CHILD_LIKES_STORY_NAME_MAP[like1];
  const text2 = CHILD_LIKES_STORY_NAME_MAP[like2];
  const text3 = CHILD_LIKES_STORY_NAME_MAP[like3];

  const fullText = `${text1}と ${text2}と ${text3}が だいすきだね。`;

  const likesTextElement: TextElement = {
    align: 'center',
    style: {
      ...Wahupop_000000_24,
      fill: BLACK,
    },
    text: fullText,
    x: 31,
    y: 227,
    width: 660,
  };

  return [
    {
      pageId: '32',
      pageImageURL: `${ASSETS_ROOT}/32027/32027.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/32027/32027.pdf`,

      text: [
        jp.SEGMENT_32_text_1,
        jp.SEGMENT_32_text_2_1,
        jp.SEGMENT_32_text_2_2,
        jp.SEGMENT_32_text_3,
      ],
    },
  ];
};
const characterObjectsS34 = (
  bookData: IBookThisIsMyDreamLineData,
  templateId: string,
): (ImageElement | TextElement)[] => {
  const patternLike: ImageElement = {
    type: 'ImageElement',
    x: 0,
    y: -1,
    imageURL: `${ASSETS_ROOT}/${templateId}/L/${templateId}-L{{assetLike}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/${templateId}/L/${templateId}-L{{assetLike}}.pdf`,
    depth: 7,
  };

  const objects: (ImageElement | TextElement)[] = [];

  const like1 = bookData.childLikes[0] ?? 'animals';
  const like2 = bookData.childLikes[1] ?? 'animals';
  const like3 = bookData.childLikes[2] ?? 'animals';
  const likeElement = likeConfig[like1]?.[like2]?.[like3];

  if (likeElement) {
    objects.push(...[resolveAssetElement(likeElement, patternLike)]);
  }

  return objects;
};

const coverColorConfig: Record<
  TCoverColor,
  AssetElement<{ templateId: string }>
> = {
  orange: {
    type: 'AssetElement',
    asset: { templateId: '00002' },
  },
  blue: {
    type: 'AssetElement',
    asset: { templateId: '00049' },
  },
  green: {
    type: 'AssetElement',
    asset: { templateId: '00053' },
  },
  pink: {
    type: 'AssetElement',
    asset: { templateId: '00057' },
  },
};

const characterObjectsCover = (
  bookData: IBookThisIsMyDreamLineData,
  coverColor: TCoverColor,
): (ImageElement | TextElement)[] => {
  const { templateId } = coverColorConfig[coverColor].asset as {
    templateId: string;
  };

  const patternSkin: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `${ASSETS_ROOT}/00002/M/00002-M{{assetSkin}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/00002/M/00002-M{{assetSkin}}.pdf`,
    depth: 8,
  };
  const patternHair: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `${ASSETS_ROOT}/00002/H/00002-H{{assetHair}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/00002/H/00002-H{{assetHair}}.pdf`,
    depth: 9,
  };
  const patternLike: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `${ASSETS_ROOT}/00002/L/00002-L{{assetLike}}.png`,
    imagePDFURL: `${ASSETS_ROOT}/00002/L/00002-L{{assetLike}}.pdf`,
    depth: 7,
  };
  const patternGlasses: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `${ASSETS_ROOT}/00002/G/00002-G01.png`,
    imagePDFURL: `${ASSETS_ROOT}/00002/G/00002-G01.pdf`,
    depth: 10,
  };

  const objects: (ImageElement | TextElement)[] = [];
  objects.push(
    ...[
      resolveAssetElement(
        skinColorConfig[bookData.clothColor][bookData.skinColor],
        patternSkin,
      ),
      resolveAssetElement(
        hairColorConfig[bookData.gender][bookData.hairColor][
          bookData.hairStyle
        ],
        patternHair,
      ),
    ],
  );

  const like1 = bookData.childLikes[0] ?? 'animals';
  const like2 = bookData.childLikes[1] ?? 'animals';
  const like3 = bookData.childLikes[2] ?? 'animals';
  const likeElement = likeConfig[like1]?.[like2]?.[like3];

  if (likeElement) {
    objects.push(...[resolveAssetElement(likeElement, patternLike)]);
  }

  if (bookData.glasses) {
    objects.push(...[...objects, patternGlasses]);
  }
  return objects;
};

// const likes_s1: {
//   [like in TChildLikesTIMDL]:
//     | ImageElement
//     | AssetElement<{ assetLike: string }>;
// } = {
//   nature: {
//     type: 'AssetElement',
//     asset: {
//       assetLike: '99030',
//     },
//   },
//   archeology: {
//     type: 'AssetElement',
//     asset: {
//       assetLike: '99031',
//     },
//   },
//   food: {
//     type: 'AssetElement',
//     asset: {
//       assetLike: '99032',
//     },
//   },
//   princesses: {
//     type: 'AssetElement',
//     asset: {
//       assetLike: '99033',
//     },
//   },
//   animals: {
//     type: 'AssetElement',
//     asset: {
//       assetLike: '99034',
//     },
//   },
//   art: {
//     type: 'AssetElement',
//     asset: {
//       assetLike: '99035',
//     },
//   },
// };

const characterObjectsLike_99030 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const patternLike: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99030/L/99030-L{{assetLike}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99030/L/99030-L{{assetLike}}.pdf`,
    depth: 7,
  };

  const objects: (ImageElement | TextElement)[] = [];
  const like1 = bookData.childLikes[0] ?? 'animals';
  const like2 = bookData.childLikes[1] ?? 'animals';
  const like3 = bookData.childLikes[2] ?? 'animals';
  const likeElement = likeConfig[like1]?.[like2]?.[like3];

  if (likeElement) {
    objects.push(...[resolveAssetElement(likeElement, patternLike)]);
  }
  return objects;
};

const characterObjectsLike_99031 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const objects: (ImageElement | TextElement)[] = [];

  return objects;
};
const characterObjectsLike_99032 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const patternLike: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99032/L/99032-L{{assetLike}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99032/L/99032-L{{assetLike}}.pdf`,
    depth: 7,
  };

  const objects: (ImageElement | TextElement)[] = [];
  const like1 = bookData.childLikes[0] ?? 'animals';
  const like2 = bookData.childLikes[1] ?? 'animals';
  const like3 = bookData.childLikes[2] ?? 'animals';
  const likeElement = likeConfig[like1]?.[like2]?.[like3];

  if (likeElement) {
    objects.push(...[resolveAssetElement(likeElement, patternLike)]);
  }

  return objects;
};
const characterObjectsLike_99033 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const patternLike: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99033/L/99033-L{{assetLike}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99033/L/99033-L{{assetLike}}.pdf`,
    depth: 7,
  };

  const objects: (ImageElement | TextElement)[] = [];
  const like1 = bookData.childLikes[0] ?? 'animals';
  const like2 = bookData.childLikes[1] ?? 'animals';
  const like3 = bookData.childLikes[2] ?? 'animals';
  const likeElement = likeConfig[like1]?.[like2]?.[like3];

  if (likeElement) {
    objects.push(...[resolveAssetElement(likeElement, patternLike)]);
  }
  return objects;
};
const characterObjectsLike_99034 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const patternLike: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99034/L/99034-L{{assetLike}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99034/L/99034-L{{assetLike}}.pdf`,
    depth: 7,
  };

  const objects: (ImageElement | TextElement)[] = [];
  const like1 = bookData.childLikes[0] ?? 'animals';
  const like2 = bookData.childLikes[1] ?? 'animals';
  const like3 = bookData.childLikes[2] ?? 'animals';
  const likeElement = likeConfig[like1]?.[like2]?.[like3];

  if (likeElement) {
    objects.push(...[resolveAssetElement(likeElement, patternLike)]);
  }
  return objects;
};
const characterObjectsLike_99035 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const patternLike: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99035/L/99035-L{{assetLike}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99035/L/99035-L{{assetLike}}.pdf`,
    depth: 7,
  };

  const objects: (ImageElement | TextElement)[] = [];
  const like1 = bookData.childLikes[0] ?? 'animals';
  const like2 = bookData.childLikes[1] ?? 'animals';
  const like3 = bookData.childLikes[2] ?? 'animals';
  const likeElement = likeConfig[like1]?.[like2]?.[like3];

  if (likeElement) {
    objects.push(...[resolveAssetElement(likeElement, patternLike)]);
  }
  return objects;
};
const characterObjectsLike_99036 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const objects: (ImageElement | TextElement)[] = [];
  return objects;
};

const characterObjectsLike_99037 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const patternLike: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99037/L/99037-L{{assetLike}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99037/L/99037-L{{assetLike}}.pdf`,
    depth: 7,
  };

  const objects: (ImageElement | TextElement)[] = [];
  const like1 = bookData.childLikes[0] ?? 'animals';
  const like2 = bookData.childLikes[1] ?? 'animals';
  const like3 = bookData.childLikes[2] ?? 'animals';
  const likeElement = likeConfig[like1]?.[like2]?.[like3];

  if (likeElement) {
    objects.push(...[resolveAssetElement(likeElement, patternLike)]);
  }
  return objects;
};

const characterObjectsLike_99038 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const objects: (ImageElement | TextElement)[] = [];
  return objects;
};
const characterObjectsLike_99039 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const objects: (ImageElement | TextElement)[] = [];
  return objects;
};
const characterObjectsLike_99040 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const objects: (ImageElement | TextElement)[] = [];
  return objects;
};
const characterObjectsLike_99041 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const objects: (ImageElement | TextElement)[] = [];
  return objects;
};

const characterObjectsLike_99042 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const patternSkin: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99042/M/99042-M{{assetSkin}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99042/M/99042-M{{assetSkin}}.pdf`,
    depth: 8,
  };

  const patternHair: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99042/H/99042-H{{assetHair}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99042/H/99042-H{{assetHair}}.pdf`,
    depth: 9,
  };

  const patternGlasses: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99042/G/99042-G01.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99042/G/99042-G01.pdf`,
    depth: 10,
  };

  const objects: (ImageElement | TextElement)[] = [];

  objects.push(
    resolveAssetElement(
      skinColorConfig[bookData.clothColor][bookData.skinColor],
      patternSkin,
    ),
    resolveAssetElement(
      hairColorConfig[bookData.gender][bookData.hairColor][bookData.hairStyle],
      patternHair,
    ),
  );

  if (bookData.glasses) {
    objects.push(patternGlasses);
  }

  return objects;
};

const characterObjectsLike_99043 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const patternSkin: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99043/M/99043-M{{assetSkin}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99043/M/99043-M{{assetSkin}}.pdf`,
    depth: 8,
  };

  const patternHair: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99043/H/99043-H{{assetHair}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99043/H/99043-H{{assetHair}}.pdf`,
    depth: 9,
  };

  const patternGlasses: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99043/G/99043-G01.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99043/G/99043-G01.pdf`,
    depth: 10,
  };

  const objects: (ImageElement | TextElement)[] = [];

  objects.push(
    resolveAssetElement(
      skinColorConfig[bookData.clothColor][bookData.skinColor],
      patternSkin,
    ),
    resolveAssetElement(
      hairColorConfig[bookData.gender][bookData.hairColor][bookData.hairStyle],
      patternHair,
    ),
  );

  if (bookData.glasses) {
    objects.push(patternGlasses);
  }

  return objects;
};

const characterObjectsLike_99044 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const patternSkin: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99044/M/99044-M{{assetSkin}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99044/M/99044-M{{assetSkin}}.pdf`,
    depth: 8,
  };

  const patternHair: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99044/H/99044-H{{assetHair}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99044/H/99044-H{{assetHair}}.pdf`,
    depth: 9,
  };

  const patternGlasses: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99044/G/99044-G01.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99044/G/99044-G01.pdf`,
    depth: 10,
  };

  const objects: (ImageElement | TextElement)[] = [];

  objects.push(
    resolveAssetElement(
      skinColorConfig[bookData.clothColor][bookData.skinColor],
      patternSkin,
    ),
    resolveAssetElement(
      hairColorConfig[bookData.gender][bookData.hairColor][bookData.hairStyle],
      patternHair,
    ),
  );

  if (bookData.glasses) {
    objects.push(patternGlasses);
  }

  return objects;
};

const characterObjectsLike_99045 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const patternSkin: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99045/M/99045-M{{assetSkin}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99045/M/99045-M{{assetSkin}}.pdf`,
    depth: 8,
  };

  const patternHair: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99045/H/99045-H{{assetHair}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99045/H/99045-H{{assetHair}}.pdf`,
    depth: 9,
  };

  const patternGlasses: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99045/G/99045-G01.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99045/G/99045-G01.pdf`,
    depth: 10,
  };

  const objects: (ImageElement | TextElement)[] = [];

  objects.push(
    resolveAssetElement(
      skinColorConfig[bookData.clothColor][bookData.skinColor],
      patternSkin,
    ),
    resolveAssetElement(
      hairColorConfig[bookData.gender][bookData.hairColor][bookData.hairStyle],
      patternHair,
    ),
  );

  if (bookData.glasses) {
    objects.push(patternGlasses);
  }

  return objects;
};

const characterObjectsLike_99046 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const patternSkin: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99046/M/99046-M{{assetSkin}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99046/M/99046-M{{assetSkin}}.pdf`,
    depth: 8,
  };

  const patternHair: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99046/H/99046-H{{assetHair}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99046/H/99046-H{{assetHair}}.pdf`,
    depth: 9,
  };

  const patternGlasses: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99046/G/99046-G01.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99046/G/99046-G01.pdf`,
    depth: 10,
  };

  const objects: (ImageElement | TextElement)[] = [];

  objects.push(
    resolveAssetElement(
      skinColorConfig[bookData.clothColor][bookData.skinColor],
      patternSkin,
    ),
    resolveAssetElement(
      hairColorConfig[bookData.gender][bookData.hairColor][bookData.hairStyle],
      patternHair,
    ),
  );

  if (bookData.glasses) {
    objects.push(patternGlasses);
  }

  return objects;
};
const characterObjectsLike_99047 = (
  bookData: IBookThisIsMyDreamLineData,
): (ImageElement | TextElement)[] => {
  const patternSkin: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99047/M/99047-M{{assetSkin}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99047/M/99047-M{{assetSkin}}.pdf`,
    depth: 8,
  };

  const patternHair: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99047/H/99047-H{{assetHair}}.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99047/H/99047-H{{assetHair}}.pdf`,
    depth: 9,
  };

  const patternGlasses: ImageElement = {
    type: 'ImageElement',
    x: -8,
    y: -8,
    imageURL: `assets/templates_this_is_my_dream_line/99047/G/99047-G01.png`,
    imagePDFURL: `assets/templates_this_is_my_dream_line/99047/G/99047-G01.pdf`,
    depth: 10,
  };

  const objects: (ImageElement | TextElement)[] = [];

  objects.push(
    resolveAssetElement(
      skinColorConfig[bookData.clothColor][bookData.skinColor],
      patternSkin,
    ),
    resolveAssetElement(
      hairColorConfig[bookData.gender][bookData.hairColor][bookData.hairStyle],
      patternHair,
    ),
  );

  if (bookData.glasses) {
    objects.push(patternGlasses);
  }

  return objects;
};

const segment6ObjectProcessors: Record<
  TChildLikesTIMDL,
  (bookData: IBookThisIsMyDreamLineData) => (ImageElement | TextElement)[]
> = {
  nature: characterObjectsLike_99030,
  archeology: characterObjectsLike_99031,
  food: characterObjectsLike_99032,
  princesses: characterObjectsLike_99033,
  animals: characterObjectsLike_99034,
  art: characterObjectsLike_99035,
};
const segment7ObjectProcessors: Record<
  TChildLikesTIMDL,
  (bookData: IBookThisIsMyDreamLineData) => (ImageElement | TextElement)[]
> = {
  nature: characterObjectsLike_99036,
  archeology: characterObjectsLike_99037,
  food: characterObjectsLike_99038,
  princesses: characterObjectsLike_99039,
  animals: characterObjectsLike_99040,
  art: characterObjectsLike_99041,
};
const segment8ObjectProcessors: Record<
  TChildLikesTIMDL,
  (bookData: IBookThisIsMyDreamLineData) => (ImageElement | TextElement)[]
> = {
  nature: characterObjectsLike_99042,
  archeology: characterObjectsLike_99043,
  food: characterObjectsLike_99044,
  princesses: characterObjectsLike_99045,
  animals: characterObjectsLike_99046,
  art: characterObjectsLike_99047,
};

// const segment0Pages: {
//   [key in TCoverColor]: Page<TPageTermsType>[];
// } = {
//   orange: [
//     {
//       pageId: '1',
//       pageImageURL: `${ASSETS_ROOT}/00002/00002.jpg`,
//       pageImagePDFURL: `${ASSETS_ROOT}/00002/00002.pdf`,
//       text: [jp.SEGMENT_0_text_1],
//     },
//   ],
//   blue: [
//     {
//       pageId: '1',
//       pageImageURL: `${ASSETS_ROOT}/00049/00049.jpg`,
//       pageImagePDFURL: `${ASSETS_ROOT}/00049/00049.pdf`,
//       text: [jp.SEGMENT_0_text_1],
//     },
//   ],
//   green: [
//     {
//       pageId: '1',
//       pageImageURL: `${ASSETS_ROOT}/00053/00053.jpg`,
//       pageImagePDFURL: `${ASSETS_ROOT}/00053/00053.pdf`,
//       text: [jp.SEGMENT_0_text_1],
//     },
//   ],
//   pink: [
//     {
//       pageId: '1',
//       pageImageURL: `${ASSETS_ROOT}/00057/00057.jpg`,
//       pageImagePDFURL: `${ASSETS_ROOT}/00057/00057.pdf`,
//       text: [jp.SEGMENT_0_text_1],
//     },
//   ],
// };

// TEXT ON PATCH
// const segment0PagesCURV = (
//   bookData: IBookThisIsMyDreamLineData,
// ): {
//   [key in TCoverColor]: Page<TPageTermsType>[];
// } => {
//   const textArr: TextElement[] = [];

//   textArr.push(
//     ...centerTextElement(
//       bookData,
//       `ゆめのでんしゃと`,
//       bookData.cover === 'hard' ? (isNode ? 0 : 30) : isNode ? 30 : 30,
//       {
//         fill: '#0b4561 ',
//         fontFamily: 'YDWTYRANNOGOCHI',
//         fontSize: 40,
//         letterSpacing: 5,
//         lineHeight: 1.5,
//         stroke: '#ffffff',
//         strokeWidth: 7,
//         fillAfterStrokeEnabled: true,
//       },
//       {
//         fill: '#0b4561 ',
//         fontFamily: 'YDWTYRANNOGOCHI',
//         fontSize: 40,
//         letterSpacing: 5,
//         lineHeight: 1.5,
//         stroke: '#ffffff',
//         strokeWidth: 9,
//         fillAfterStrokeEnabled: true,
//       },
//       40,
//       40,
//     ),
//   );
//   textArr.push(
//     ...centerTextElementOnArc(
//       bookData,
//       `[{{heroName}}]{{kidstitle}}`,
//       bookData.cover === 'hard' ? (isNode ? 0 : 80) : 80,
//       {
//         fill: '#0b4561',
//         fontFamily: 'YDWTYRANNOGOCHI',
//         fontSize: 70,
//         letterSpacing: 5,
//         lineHeight: 0.8,
//         stroke: '#ffffff',
//         strokeWidth: 12,
//         fillAfterStrokeEnabled: true,
//       },
//       {
//         fill: '#0b4561',
//         fontFamily: 'YDWTYRANNOGOCHI',
//         fontSize: 40,
//         letterSpacing: 5,
//         lineHeight: 1.7,
//         stroke: '#ffffff',
//         strokeWidth: 8,
//         fillAfterStrokeEnabled: true,
//       },
//       75,
//       40,

//       // Радиус дуги
//       900,
//     ),
//   );

//   return {
//     orange: [
//       {
//         pageId: '1',
//         pageImageURL: `${ASSETS_ROOT}/00002/00002.jpg`,
//         pageImagePDFURL: `${ASSETS_ROOT}/00002/00002.pdf`,
//         text: textArr,
//       },
//     ],

//     blue: [
//       {
//         pageId: '1',
//         pageImageURL: `${ASSETS_ROOT}/00049/00049.jpg`,
//         pageImagePDFURL: `${ASSETS_ROOT}/00049/00049.pdf`,
//         text: textArr,
//       },
//     ],

//     green: [
//       {
//         pageId: '1',
//         pageImageURL: `${ASSETS_ROOT}/00053/00053.jpg`,
//         pageImagePDFURL: `${ASSETS_ROOT}/00053/00053.pdf`,
//         text: textArr,
//       },
//     ],

//     pink: [
//       {
//         pageId: '1',
//         pageImageURL: `${ASSETS_ROOT}/00057/00057.jpg`,
//         pageImagePDFURL: `${ASSETS_ROOT}/00057/00057.pdf`,
//         text: textArr,
//       },
//     ],
//   };
// };
const segment0Pages = (
  bookData: IBookThisIsMyDreamLineData,
): {
  [key in TCoverColor]: Page<TPageTermsType>[];
} => {
  const textArr: TextElement[] = [];

  textArr.push(
    ...centerTextElement(
      bookData,
      `[{{heroName}}{{kidstitle}}]の`,
      bookData.cover === 'hard' ? (isNode ? 0 : 40) : isNode ? 40 : 40,
      {
        fill: '#0b4561',
        fontFamily: 'YDWTYRANNOGOCHI',
        fontSize: 70,
        letterSpacing: 1,
        lineHeight: 0.8,
        stroke: '#ffffff',
        strokeWidth: 15,
        fillAfterStrokeEnabled: true,
      },
      {
        fill: '#0b4561 ',
        fontFamily: 'YDWTYRANNOGOCHI',
        fontSize: 55,
        letterSpacing: 5,
        lineHeight: 0.5,
        stroke: '#ffffff',
        strokeWidth: 13,
        fillAfterStrokeEnabled: true,
      },
      65,
      40,
    ),
  );
  textArr.push(
    ...leftTextElement(
      bookData,
      `ゆめのでんしゃ`,
      bookData.cover === 'hard' ? (isNode ? 0 : 145) : isNode ? 145 : 145,
      {
        fill: '#0b4561 ',
        fontFamily: 'YDWTYRANNOGOCHI',
        fontSize: 47,
        letterSpacing: 5,
        lineHeight: 1.5,
        stroke: '#ffffff',
        strokeWidth: 7,
        fillAfterStrokeEnabled: true,
      },
      {
        fill: '#0b4561 ',
        fontFamily: 'YDWTYRANNOGOCHI',
        fontSize: 48,
        letterSpacing: 5,
        lineHeight: 1.5,
        stroke: '#ffffff',
        strokeWidth: 13,
        fillAfterStrokeEnabled: true,
      },
      40,
      43,
      430,
    ),
  );

  return {
    orange: [
      {
        pageId: '1',
        pageImageURL: `${ASSETS_ROOT}/00002/00002.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/00002/00002.pdf`,
        text: textArr,
      },
    ],

    blue: [
      {
        pageId: '1',
        pageImageURL: `${ASSETS_ROOT}/00049/00049.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/00049/00049.pdf`,
        text: textArr,
      },
    ],

    green: [
      {
        pageId: '1',
        pageImageURL: `${ASSETS_ROOT}/00053/00053.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/00053/00053.pdf`,
        text: textArr,
      },
    ],

    pink: [
      {
        pageId: '1',
        pageImageURL: `${ASSETS_ROOT}/00057/00057.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/00057/00057.pdf`,
        text: textArr,
      },
    ],
  };
};

const segment35Pages: {
  [key in TCoverColor]: Page<TPageTermsType>[];
} = {
  orange: [
    {
      pageId: '35',
      pageImageURL: `${ASSETS_ROOT}/00001/00001.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/00001/00001.pdf`,
    },
  ],
  blue: [
    {
      pageId: '35',
      pageImageURL: `${ASSETS_ROOT}/00048/00048.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/00048/00048.pdf`,
    },
  ],
  green: [
    {
      pageId: '35',
      pageImageURL: `${ASSETS_ROOT}/00052/00052.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/00052/00052.pdf`,
    },
  ],
  pink: [
    {
      pageId: '35',
      pageImageURL: `${ASSETS_ROOT}/00056/00056.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/00056/00056.pdf`,
    },
  ],
};

const segment6_12_18Pages: {
  [key in TChildLikesTIMDL]: Page<TPageTermsType>[];
} = {
  nature: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99030/99030.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99030/99030.pdf`,
      text: [jp.SEGMENT_99030_text_1],
    },
  ],
  archeology: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99031/99031.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99031/99031.pdf`,
      text: [jp.SEGMENT_99031_text_1],
    },
  ],
  food: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99032/99032.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99032/99032.pdf`,
      text: [jp.SEGMENT_99032_text_1],
    },
  ],
  princesses: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99033/99033.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99033/99033.pdf`,
      text: [jp.SEGMENT_99033_text_1],
    },
  ],
  animals: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99034/99034.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99034/99034.pdf`,
      text: [jp.SEGMENT_99034_text_1],
    },
  ],
  art: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99035/99035.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99035/99035.pdf`,
      text: [jp.SEGMENT_99035_text_1, jp.SEGMENT_99035_text_2],
    },
  ],
};
const segment7_13_19Pages: {
  [key in TChildLikesTIMDL]: Page<TPageTermsType>[];
} = {
  nature: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99036/99036.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99036/99036.pdf`,
    },
  ],
  archeology: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99037/99037.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99037/99037.pdf`,
      text: [jp.SEGMENT_99037_text_1],
    },
  ],
  food: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99038/99038.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99038/99038.pdf`,
      text: [jp.SEGMENT_99038_text_1],
    },
  ],
  princesses: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99039/99039.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99039/99039.pdf`,
    },
  ],
  animals: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99040/99040.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99040/99040.pdf`,
    },
  ],
  art: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99041/99041.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99041/99041.pdf`,
    },
  ],
};
const segment8_14_20Pages: {
  [key in TChildLikesTIMDL]: Page<TPageTermsType>[];
} = {
  nature: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99042/99042.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99042/99042.pdf`,
      text: [jp.SEGMENT_99042_text_1, jp.SEGMENT_99042_text_2],
    },
  ],
  archeology: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99043/99043.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99043/99043.pdf`,
      text: [jp.SEGMENT_99043_text_1, jp.SEGMENT_99043_text_2],
    },
  ],
  food: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99044/99044.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99044/99044.pdf`,
      text: [jp.SEGMENT_99044_text_1],
    },
  ],
  princesses: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99045/99045.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99045/99045.pdf`,
      text: [jp.SEGMENT_99045_text_1, jp.SEGMENT_99045_text_2],
    },
  ],
  animals: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99046/99046.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99046/99046.pdf`,
      text: [jp.SEGMENT_99046_text_1, jp.SEGMENT_99046_text_2],
    },
  ],
  art: [
    {
      pageId: '1',
      pageImageURL: `${ASSETS_ROOT}/99047/99047.jpg`,
      pageImagePDFURL: `${ASSETS_ROOT}/99047/99047.pdf`,
      text: [jp.SEGMENT_99047_text_1, jp.SEGMENT_99047_text_2],
    },
  ],
};

const CHILD_LIKES_STORY_NAME_MAP: { [like in TChildLikesTIMDL]: string } = {
  nature: 'しぜん',
  archeology: 'きょうりゅう',
  food: 'たべもの',
  princesses: 'かわいいもの',
  animals: 'どうぶつ',
  art: 'あーと',
};
const CHILD_LIKES_STATION_NAME_MAP: { [like in TChildLikesTIMDL]: string } = {
  nature: 'むしのもりえき',
  archeology: 'きょうりゅうえき',
  food: 'たべものえき',
  princesses: 'かわいいものえき',
  animals: 'どうぶつえき',
  art: 'あーとえき',
};

const likesTextProcessor = (
  bookData: IBookThisIsMyDreamLineData,
  _textStr: string,
): string => {
  let textStr = textProcessor(bookData, _textStr);

  textStr = textStr.replace(
    '{{1st train station}}',
    CHILD_LIKES_STATION_NAME_MAP[bookData.childLikes[0]!],
  );
  textStr = textStr.replace(
    '{{1st like}}',
    CHILD_LIKES_STORY_NAME_MAP[bookData.childLikes[0]!],
  );
  textStr = textStr.replace(
    '{{2nd like}}',
    CHILD_LIKES_STORY_NAME_MAP[bookData.childLikes[1]!],
  );
  textStr = textStr.replace(
    '{{3rd like}}',
    CHILD_LIKES_STORY_NAME_MAP[bookData.childLikes[2]!],
  );
  return textStr;
};

const LIKE_ORDER_TEXT_MAP = ['さいしょに', 'つぎに', 'さいごに'] as const;
const LIKE_ORDER_TEXT_MAP_FINAL = ['さいしょに', 'つぎに', 'さいごに'] as const;

const stationOrderTextProcessor = (
  bookData: IBookThisIsMyDreamLineData,
  _textStr: string,
  likeIndex: 0 | 1 | 2,
): string => {
  let textStr = textProcessor(bookData, _textStr);

  textStr = textStr.replace('{{stationOrder}}', LIKE_ORDER_TEXT_MAP[likeIndex]);
  textStr = textStr.replace(
    '{{stationOrderFinal}}',
    LIKE_ORDER_TEXT_MAP_FINAL[likeIndex],
  );

  return textStr;
};

/**
 * ! segments 13-21 originally branched on lets-make-metro's `storyLine`, a field this book
 * doesn't have. Each is pinned to a single (real, existing) variant of that page so nothing
 * crashes; swap in dedicated content/art once available.
 */
const segments = [
  {
    segmentId: '0',
    textProcessor: (bookData, text) => textProcessor(bookData, text),
    objectProcessor: (bookData) =>
      characterObjectsCover(bookData, bookData.coverColor),
    getPages: (bookData: IBookThisIsMyDreamLineData) =>
      segment0Pages(bookData)[bookData.coverColor],
    pages: [],
  } as TSegment,
  {
    segmentId: '1',
    textProcessor: (bookData, text) => textProcessor(bookData, text),
    pages: [
      {
        pageId: '1',
        pageImageURL: `${ASSETS_ROOT}/01005/01005.png`,
        pageImagePDFURL: `${ASSETS_ROOT}/01005/01005.pdf`,
        photoPosition: {
          x: 141,
          y: 106,
          width: 240,
          height: 335,
          rotation: 4,
        },
        data: {
          messageRect: {
            x: 381,
            y: 150,
            // width: 395,
            width: 403,
            height: 202,
            rotation: 3,
            style: {
              fill: '#000000',
              fontFamily: 'APJapanesefont',
              fontSize: 16,
              letterSpacing: 1,
              align: 'center',
            },
          },
        },
      },
    ],
  } as TSegment,
  {
    segmentId: '2',
    textProcessor: (bookData, text) => textProcessor(bookData, text),
    objectProcessor: (bookData) => characterObjects(bookData, '02006'),
    pages: [
      {
        pageId: '2',
        pageImageURL: `${ASSETS_ROOT}/02006/02006.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/02006/02006.pdf`,
        text: [jp.SEGMENT_2_text_1],
      },
    ],
  } as TSegment,
  {
    segmentId: '3',
    pages: [
      {
        pageId: '3',
        pageImageURL: `${ASSETS_ROOT}/03007/03007.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/03007/03007.pdf`,
      },
    ],
  } as TSegment,
  {
    segmentId: '4',
    objectProcessor: (bookData) => characterObjectsS4(bookData, '04008'),
    pages: [
      {
        pageId: '4',
        pageImageURL: `${ASSETS_ROOT}/04008/04008.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/04008/04008.pdf`,
      },
    ],
  } as TSegment,
  {
    segmentId: '5',
    textProcessor: (bookData, text) => likesTextProcessor(bookData, text),
    objectProcessor: (bookData) => characterObjectsS5(bookData, '05009'),

    getPages: (bookData: IBookThisIsMyDreamLineData) => {
      const pages: Segment<
        TSegmentTermsType,
        TPageTermsType,
        IBookThisIsMyDreamLineData
      >['pages'] = [];
      const textArr: TextElement[] = [];

      textArr.push(
        ...centerTextElement5(
          bookData,
          jp.SEGMENT_5_text_value_1,
          92,
          {
            fontSize: 24,
            fontFamily: 'BUILDINGSANDUNDERTHERAILWAYTRACKSFREE_VER',
            fill: '#000000',
          },
          {
            fontSize: 20,
            fontFamily: 'BUILDINGSANDUNDERTHERAILWAYTRACKSFREE_VER',
            fill: '#000000',
            lineHeight: 1,
          },
          18,
          13,
        ),
      );
      textArr.push(jp.SEGMENT_5_text_2, jp.SEGMENT_5_text_3);
      pages.push({
        pageId: '30',
        pageImageURL: `${ASSETS_ROOT}/05009/05009.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/05009/05009.pdf`,
        text: textArr,
      });
      return pages;
    },

    pages: [],
  } as TSegment,
  {
    segmentId: '6',

    textProcessor: (bookData, text) =>
      stationOrderTextProcessor(bookData, text, 0),

    objectProcessor: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[0];

      if (!childLike) {
        return [];
      }

      return segment6ObjectProcessors[childLike](bookData);
    },

    getPages: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[0];

      return childLike ? segment6_12_18Pages[childLike] : [];
    },

    pages: [],
  } as TSegment,
  {
    segmentId: '7',

    textProcessor: (bookData, text) => textProcessor(bookData, text),

    objectProcessor: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[0];

      if (!childLike) {
        return [];
      }

      return segment7ObjectProcessors[childLike](bookData);
    },

    getPages: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[0];

      return childLike ? segment7_13_19Pages[childLike] : [];
    },

    pages: [],
  } as TSegment,
  {
    segmentId: '8',

    textProcessor: (bookData, text) => textProcessor(bookData, text),

    objectProcessor: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[0];

      if (!childLike) {
        return [];
      }

      return segment8ObjectProcessors[childLike](bookData);
    },

    getPages: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[0];

      return childLike ? segment8_14_20Pages[childLike] : [];
    },

    pages: [],
  } as TSegment,
  {
    segmentId: '9',
    objectProcessor: (bookData) => characterObjects(bookData, '09010'),

    pages: [
      {
        pageId: '9',
        pageImageURL: `${ASSETS_ROOT}/09010/09010.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/09010/09010.pdf`,
      },
    ],
  } as TSegment,
  {
    segmentId: '10',
    objectProcessor: (bookData) => characterObjects(bookData, '10011'),

    pages: [
      {
        pageId: '10',
        pageImageURL: `${ASSETS_ROOT}/10011/10011.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/10011/10011.pdf`,
      },
    ],
  } as TSegment,
  {
    segmentId: '11',
    textProcessor: (bookData, text) => textProcessor(bookData, text),
    pages: [
      {
        pageId: '11',
        pageImageURL: `${ASSETS_ROOT}/11012/11012.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/11012/11012.pdf`,
        text: [jp.SEGMENT_11_text_1],
      },
    ],
  } as TSegment,
  {
    segmentId: '12',

    textProcessor: (bookData, text) =>
      stationOrderTextProcessor(bookData, text, 1),

    objectProcessor: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[1];

      if (!childLike) {
        return [];
      }

      return segment6ObjectProcessors[childLike](bookData);
    },

    getPages: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[1];

      return childLike ? segment6_12_18Pages[childLike] : [];
    },

    pages: [],
  } as TSegment,
  {
    segmentId: '13',

    textProcessor: (bookData, text) => textProcessor(bookData, text),

    objectProcessor: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[1];

      if (!childLike) {
        return [];
      }

      return segment7ObjectProcessors[childLike](bookData);
    },

    getPages: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[1];

      return childLike ? segment7_13_19Pages[childLike] : [];
    },

    pages: [],
  } as TSegment,
  {
    segmentId: '14',

    textProcessor: (bookData, text) => textProcessor(bookData, text),

    objectProcessor: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[1];

      if (!childLike) {
        return [];
      }

      return segment8ObjectProcessors[childLike](bookData);
    },

    getPages: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[1];

      return childLike ? segment8_14_20Pages[childLike] : [];
    },

    pages: [],
  } as TSegment,
  {
    segmentId: '15',
    textProcessor: (bookData, text) => textProcessor(bookData, text),
    objectProcessor: (bookData) => characterObjects(bookData, '15013'),
    pages: [
      {
        pageId: '15',
        pageImageURL: `${ASSETS_ROOT}/15013/15013.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/15013/15013.pdf`,
        text: [jp.SEGMENT_15_text_1],
      },
    ],
  } as TSegment,
  {
    segmentId: '16',
    pages: [
      {
        pageId: '16',
        pageImageURL: `${ASSETS_ROOT}/16014/16014.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/16014/16014.pdf`,
      },
    ],
  } as TSegment,
  {
    segmentId: '17',
    textProcessor: (bookData, text) => textProcessor(bookData, text),
    objectProcessor: (bookData) => characterObjects(bookData, '17015'),
    pages: [
      {
        pageId: '17',
        pageImageURL: `${ASSETS_ROOT}/17015/17015.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/17015/17015.pdf`,
        text: [jp.SEGMENT_17_text_1],
      },
    ],
  } as TSegment,
  {
    segmentId: '18',

    textProcessor: (bookData, text) =>
      stationOrderTextProcessor(bookData, text, 2),

    objectProcessor: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[2];

      if (!childLike) {
        return [];
      }

      return segment6ObjectProcessors[childLike](bookData);
    },

    getPages: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[2];

      return childLike ? segment6_12_18Pages[childLike] : [];
    },

    pages: [],
  } as TSegment,
  {
    segmentId: '19',

    textProcessor: (bookData, text) => textProcessor(bookData, text),

    objectProcessor: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[2];

      if (!childLike) {
        return [];
      }

      return segment7ObjectProcessors[childLike](bookData);
    },

    getPages: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[2];

      return childLike ? segment7_13_19Pages[childLike] : [];
    },

    pages: [],
  } as TSegment,
  {
    segmentId: '20',

    textProcessor: (bookData, text) => textProcessor(bookData, text),

    objectProcessor: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[2];

      if (!childLike) {
        return [];
      }

      return segment8ObjectProcessors[childLike](bookData);
    },

    getPages: (bookData: IBookThisIsMyDreamLineData) => {
      const childLike = bookData.childLikes[2];

      return childLike ? segment8_14_20Pages[childLike] : [];
    },

    pages: [],
  } as TSegment,
  {
    segmentId: '21',
    textProcessor: (bookData, text) => textProcessor(bookData, text),
    objectProcessor: (bookData) => characterObjects(bookData, '21016'),
    pages: [
      {
        pageId: '21',
        pageImageURL: `${ASSETS_ROOT}/21016/21016.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/21016/21016.pdf`,
        text: [jp.SEGMENT_21_text_1],
      },
    ],
  } as TSegment,
  {
    segmentId: '22',
    pages: [
      {
        pageId: '22',
        pageImageURL: `${ASSETS_ROOT}/22017/22017.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/22017/22017.pdf`,
      },
    ],
  } as TSegment,
  {
    segmentId: '23',
    textProcessor: (bookData, text) => textProcessor(bookData, text),
    objectProcessor: (bookData) => characterObjects(bookData, '23018'),
    pages: [
      {
        pageId: '23',
        pageImageURL: `${ASSETS_ROOT}/23018/23018.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/23018/23018.pdf`,
        text: [jp.SEGMENT_23_text_1],
      },
    ],
  } as TSegment,
  {
    segmentId: '24',
    textProcessor: (bookData, text) => textProcessor(bookData, text),
    objectProcessor: (bookData) => characterObjects(bookData, '24019'),
    pages: [
      {
        pageId: '24',
        pageImageURL: `${ASSETS_ROOT}/24019/24019.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/24019/24019.pdf`,
        text: [jp.SEGMENT_24_text_1],
      },
    ],
  } as TSegment,
  {
    segmentId: '25',
    textProcessor: (bookData, text) => textProcessor(bookData, text),
    pages: [
      {
        pageId: '25',
        pageImageURL: `${ASSETS_ROOT}/25020/25020.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/25020/25020.pdf`,
        text: [jp.SEGMENT_25_text_1],
      },
    ],
  } as TSegment,
  {
    segmentId: '26',
    objectProcessor: (bookData) => characterObjects(bookData, '26021'),
    pages: [
      {
        pageId: '26',
        pageImageURL: `${ASSETS_ROOT}/26021/26021.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/26021/26021.pdf`,
      },
    ],
  } as TSegment,
  {
    segmentId: '27',
    textProcessor: (bookData, text) => textProcessor(bookData, text),
    pages: [
      {
        pageId: '27',
        pageImageURL: `${ASSETS_ROOT}/27022/27022.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/27022/27022.pdf`,
        text: [jp.SEGMENT_27_text_1],
      },
    ],
  } as TSegment,
  {
    segmentId: '28',
    pages: [
      {
        pageId: '28',
        pageImageURL: `${ASSETS_ROOT}/28023/28023.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/28023/28023.pdf`,
      },
    ],
  } as TSegment,
  {
    segmentId: '29',
    pages: [
      {
        pageId: '29',
        pageImageURL: `${ASSETS_ROOT}/29024/29024.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/29024/29024.pdf`,
      },
    ],
  } as TSegment,
  {
    segmentId: '30',
    objectProcessor: (bookData) => characterObjectsS30(bookData, '30025'),
    getPages: (bookData: IBookThisIsMyDreamLineData) => {
      const pages: Segment<
        TSegmentTermsType,
        TPageTermsType,
        IBookThisIsMyDreamLineData
      >['pages'] = [];
      const textArr: TextElement[] = [];

      textArr.push(
        ...centerTextElement30(
          bookData,
          jp.SEGMENT_30_text_value_1,
          431,
          {
            fontSize: 23,
            fontFamily: 'BUILDINGSANDUNDERTHERAILWAYTRACKSFREE_VER',
            fill: '#000000',
          },
          {
            fontSize: 20,
            fontFamily: 'APJapanesefont',
            fill: '#000000',
            lineHeight: 1,
          },
          18,
          13,
        ),
      );

      pages.push({
        pageId: '30',
        pageImageURL: `${ASSETS_ROOT}/30025/30025.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/30025/30025.pdf`,
        text: textArr,
      });
      return pages;
    },

    pages: [],
  } as TSegment,
  {
    segmentId: '31',
    objectProcessor: (bookData) => characterObjects(bookData, '31026'),
    pages: [
      {
        pageId: '31',
        pageImageURL: `${ASSETS_ROOT}/31026/31026.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/31026/31026.pdf`,
      },
    ],
  } as TSegment,
  {
    segmentId: '32',

    textProcessor: (bookData, text) => likesTextProcessor(bookData, text),

    objectProcessor: (bookData) => characterObjectsS32(bookData, '32027'),

    getPages: (bookData) => segment32Pages(bookData),
    pages: [],
  } as TSegment,
  {
    segmentId: '33',
    objectProcessor: (bookData) => characterObjects(bookData, '33028'),
    pages: [
      {
        pageId: '33',
        pageImageURL: `${ASSETS_ROOT}/33028/33028.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/33028/33028.pdf`,
      },
    ],
  } as TSegment,
  {
    segmentId: '34',
    textProcessor: (bookData, text) => textProcessor(bookData, text),
    objectProcessor: (bookData) => characterObjectsS34(bookData, '34029'),
    pages: [
      {
        pageId: '34',
        pageImageURL: `${ASSETS_ROOT}/34029/34029.jpg`,
        pageImagePDFURL: `${ASSETS_ROOT}/34029/34029.pdf`,
        text: [jp.SEGMENT_34_text_1],
      },
    ],
  } as TSegment,
  {
    segmentId: '35',
    getPages: (bookData: IBookThisIsMyDreamLineData) =>
      segment35Pages[bookData.coverColor],
    pages: [],
  } as TSegment,
] as const;

export default segments;
export const SEGMENTS_LIST_FONTS_MAP = segmentsListToFontsMap<
  typeof segments,
  TLanguage
>(segments, languageArr as unknown as TLanguage[], {
  [INPUT_VALUE_JAPANESE]: new Set([
    'YDWTYRANNOGOCHI',
    'KozGoProRegular',
    'KozGoProBold',
    'APJapanesefont',
    'Wahupop',
    'Kaisei Opti',
    'BUILDINGSANDUNDERTHERAILWAYTRACKSFREE_VER',
  ]),
  [INPUT_VALUE_ENGLISH]: new Set([]),
});
export * from './_utils';
